import React from 'react';
import ReactModal from 'react-modal';
import styles from './Modal.module.sass'

ReactModal.setAppElement('.container');

const Modal = ({ closeModal, modalIsOpen, className, modalBodyProps = {},
                 label, children, headerText, primaryButton, secondaryButton,
                 modalHeaderClassName, footerClass }) => {
  const closeButton = () => (
    <button
      type="button"
      className={`close ${styles.closeButton}`}
      onClick={closeModal}
      onKeyPress={closeModal}
      aria-label="Close popup"
    >
      ✕
    </button>
  )
  return (
    <ReactModal
      portalClassName="modal-portal"
      overlayClassName={styles.overlayBackground}
      className={`${styles.modalContainer} ${className}`}
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel={label}
    >
      <header className={modalHeaderClassName}>
        {closeButton()}
        <h1 className={styles.modalHeader}>{headerText}</h1>
        <div className={styles.modalCloseButton} onClick={closeModal} />
      </header>
      <div {...modalBodyProps} className={`${styles.modalBody} ${modalBodyProps.className}`}>
        {children}
      </div>
      <div className={`${styles.modalFooter} ${footerClass}`}>
        {secondaryButton}
        {primaryButton}
      </div>
    </ReactModal>
  );
};
export default Modal;
